
import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import Swal from 'sweetalert2';
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import { Select } from "antd";
import { fetchOrganizations } from "../services/organizationServices";
import { fetchDepartments } from "../services/departmentsServices";
import { addSection, fetchSections, inActiveSection, updateSection } from "../services/sectionServices";
import { useNavigate } from "react-router-dom";

export default function SectionsByDepartment() {

    const { Option } = Select;
    const [sessionUserData, setSessionUserData] = useState([]);
    const [departmentsData, setDepartmentsData] = useState([]);
    const [addEditdepartmentsData, setAddEditDepartmentsData] = useState([]);
    const [sectionsData, setSectionsData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [dataSubLoading, setDataSubLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [nameInput, setNameInput] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [organizationsData, setOrganizationsData] = useState([]);
    const [getSelectedOrgId, SetGetSelectedOrgId] = useState(null);
    const [getSelectedDeptId, setGetSelectedDeptId] = useState(null);
    const [addEditSelectedDeptId, setAddEditSelectedDeptId] = useState(null);
    const [addEditSelectedOrgId, setAddEditSelectedOrgId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    useEffect(() => {
        fetchDepartments();
    }, []);

    useEffect(() => {
        getOrganizations();
    }, []);

    useEffect(() => {
        getDepartments();
    }, [getSelectedOrgId]);

    useEffect(() => {
        getAddEditDepartments();
    }, [addEditSelectedOrgId]);

    useEffect(() => {
        getSections();
    }, [getSelectedDeptId]);

    const getOrganizations = async () => {
        try {
            const data = await fetchOrganizations();
            setOrganizationsData(data);
        } catch (error) {
            console.error('Failed to load organizations:', error);
        } finally {
            console.log('Organization fetch completed');
        }
    };

    const getDepartments = async () => {
        try {
            const data = await fetchDepartments(getSelectedOrgId);
            setDepartmentsData(data);
        } catch (error) {
            console.error('Failed to load departments:', error);
        } finally {
            console.log('Fetched departments..!')
        }
    };

    const getAddEditDepartments = async () => {
        try {
            const data = await fetchDepartments(addEditSelectedOrgId);
            setAddEditDepartmentsData(data);
        } catch (error) {
            console.error('Failed to load departments:', error);
        } finally {
            console.log('Fetched departments..!')
        }
    };

    const getSections = async () => {
        try {
            const data = await fetchSections(getSelectedDeptId);
            setSectionsData(data);
        } catch (error) {
            console.error('Failed to load sections:', error);
        } finally {
            console.log('Fetched sections..!')
        }
    };

    const filteredData = sectionsData && sectionsData?.filter((item) => {
        const disValue = item?.DisplayValue?.toLowerCase() || '';

        const query = searchQuery.toLowerCase();

        return (
            disValue.includes(query)
        );
    });

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 5;
    const totalPages = filteredData?.length ? Math.ceil(filteredData?.length / recordsPerPage) : 0;

    // Get current records to display
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData?.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleEditClick = (item) => {
        setEditMode(true);
        setEditingItem(item);
        setNameInput(item.SectionName);
        setAddEditSelectedOrgId(item.OrgId);
        setAddEditSelectedDeptId(item.DeptId);
    };

    const handleSubmit = async () => {
        if (!nameInput.trim()) return;

        try {
            setDataSubLoading(true);
            if (editMode && editingItem) {
                await updateSection({
                    SectionId: editingItem.SectionId,
                    SectionName: nameInput,
                    DeptId: addEditSelectedDeptId,
                    UpdatedBy: sessionUserData?.Id
                });
                } else {
                await addSection({
                    OrgId: addEditSelectedOrgId,
                    SectionName: nameInput,
                    DeptId: addEditSelectedDeptId,
                    CreatedBy: sessionUserData?.Id
                });
            }

            setNameInput('');
            setDataSubLoading(false);
            setEditMode(false);
            setEditingItem(null);
            getDepartments();

        } catch (error) {
            console.error("Error submitting content type:", error);
            setDataSubLoading(false);
        }
    };

    const handleDelete = async (item) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete section "${item.SectionName}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
          });
        
          if (result.isConfirmed) {
            try {
          
                const response = await inActiveSection({
                  SectionId: item.SectionId,
                  UpdatedBy: sessionUserData?.Id,
                });
                if (response.data.ResultData.Status === 'Success') {
                    Swal.fire('Deleted!', 'The section has been deleted.', 'success');
                    getDepartments();
                } else {
                    Swal.fire('Delete!', 'Failed to delete section, try after sometime..!.', 'error');
                }
          
                handleClear();
              } catch (error) {
                console.error('Error deleting section:', error);
                Swal.fire('Error', 'Something went wrong!', 'error');
              } finally {
                setDataSubLoading(false);
              }
            }
          };

    const handleClear = () => {
        setNameInput('');
        setEditMode(false);
        setEditingItem(null);
        setDataSubLoading(false);
        setAddEditSelectedDeptId(null);
        setAddEditSelectedOrgId(null);
    };


    return (
        <MainLayout>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Sections</h4>
                            <h6>Manage your sections</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>
                    </ul>
                </div>
                <div className="row justify-content-evenly">
                    <div className="card col-6">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <div className="row w-100 align-items-center">
                                    {/* Select Dropdown */}
                                    <div className="col-md-6 mb-2">
                                        <Select
                                            showSearch
                                            allowClear
                                            placeholder="Select Organization"
                                            className="w-100"
                                            style={{ height: '2.4rem' }}
                                            value={getSelectedOrgId || undefined}
                                            onChange={(value) => SetGetSelectedOrgId(value)}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {organizationsData && organizationsData?.map((org) => (
                                                <Option key={org.OrgId} value={org.OrgId}>
                                                    {org.OrgName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="col-md-6 mb-2">
                                        <Select
                                            showSearch
                                            allowClear
                                            placeholder="Select Department"
                                            className="w-100"
                                            style={{ height: '2.4rem' }}
                                            value={getSelectedDeptId || undefined}
                                            onChange={(value) => setGetSelectedDeptId(value)}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                        >
                                            {departmentsData && departmentsData?.map((dep) => (
                                                <Option key={dep.Id} value={dep.Id}>
                                                    {dep.DeptName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="col-12 mb-2">
                                        <div className="d-flex align-items-center position-relative my-1">
                                            <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                            <input
                                                type="text"
                                                data-kt-customer-table-filter="search"
                                                className="form-control form-control-solid ps-13"
                                                placeholder="Search department"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-toolbar">
                                <div className="d-flex justify-content-end" data-kt-customer-table-toolbar="base"></div>
                                <div className="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                                    <div className="fw-bold me-5">
                                        <span className="me-2" data-kt-customer-table-select="selected_count"></span>Selected</div>
                                    <button type="button" className="btn btn-danger" data-kt-customer-table-select="delete_selected">Delete Selected</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_customers_table">
                                    <thead>
                                        <tr className="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                                            <th className="">S.No</th>
                                            <th className="min-w-125px">Name</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600">
                                        {dataLoading ? (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <div className="container"></div>
                                                </td>
                                            </tr>
                                        ) : !getSelectedDeptId ? (
                                            <tr>
                                                <td colSpan="12" className="text-center text-muted">
                                                <p>Please select an organization & department</p>
                                                </td>
                                            </tr>
                                        ) : currentRecords && currentRecords.length > 0 ? (
                                            currentRecords.map((item, index) => (
                                                <tr>
                                                    <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                    <td>
                                                        <a className="text-gray-800 text-hover-primary mb-1">{item.SectionName}</a>
                                                    </td>
                                                    <td className="text-center">
                                                        <i
                                                            className="fa-regular fa-pen-to-square text-info"
                                                            onClick={() => handleEditClick(item)}
                                                            title="Edit Section"
                                                            style={{
                                                                cursor: 'pointer',
                                                                transition: 'transform 0.2s',
                                                            }}
                                                            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
                                                            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                        ></i>

                                                        <i
                                                            className="fa-regular fa-trash-can text-danger ms-2"
                                                            onClick={() => handleDelete(item)}
                                                            title="Delete Section"
                                                            style={{
                                                            cursor: 'pointer',
                                                            transition: 'transform 0.2s',
                                                            }}
                                                            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.2)')}
                                                            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <p>No Data Available</p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div className="dt-paging paging_simple_numbers">
                                    <nav aria-label="pagination">
                                        <ul className="pagination">
                                            <li
                                                className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                            >
                                                <button
                                                    className="page-link previous"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-disabled={currentPage === 1}
                                                    aria-label="Previous"
                                                    onClick={handlePrevious}
                                                >
                                                    <i className="previous"></i>
                                                </button>
                                            </li>

                                            {/* Page Numbers */}
                                            {getPaginationNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        role="link"
                                                        type="button"
                                                        aria-controls="kt_customers_table"
                                                        aria-current={page === currentPage ? "page" : undefined}
                                                        onClick={() => handlePageClick(page)}
                                                        disabled={page === "..."}
                                                    >
                                                        {page}
                                                    </button>
                                                </li>
                                            ))}

                                            {/* Next Button */}
                                            <li
                                                className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                            >
                                                <button
                                                    className="page-link next"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-disabled={currentPage === totalPages}
                                                    aria-label="Next"
                                                    onClick={handleNext}
                                                >
                                                    <i className="next"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card col-6">
                        <div className="card-header border-0 pt-6">
                            <div className="card-title">
                                <h3>{editMode ? "Edit Section" : "Add Section"}</h3>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    <label className="form-label">Organization</label>
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Select Organization"
                                        className="w-100"
                                        style={{ height: '2.4rem' }}
                                        value={addEditSelectedOrgId || undefined}
                                        onChange={(value) => setAddEditSelectedOrgId(value)}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        disabled={editMode}
                                    >
                                        {organizationsData && organizationsData?.map((org) => (
                                            <Option key={org.OrgId} value={org.OrgId}>
                                                {org.OrgName}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <label className="form-label">Department</label>
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="Select Department"
                                        className="w-100"
                                        style={{ height: '2.4rem' }}
                                        value={addEditSelectedDeptId || undefined}
                                        onChange={(value) => setAddEditSelectedDeptId(value)}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        disabled={editMode}
                                    >
                                        {addEditdepartmentsData && addEditdepartmentsData?.map((dep) => (
                                            <Option key={dep.Id} value={dep.Id}>
                                                {dep.DeptName}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <div>
                                    <label className="form-label">Name</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Enter section name"
                                        value={nameInput}
                                        onChange={(e) => setNameInput(e.target.value)}
                                    />
                                </div>
                                <div className="d-flex justify-content-center mt-4">
                                    <button
                                        className="btn btn-secondary col-2 me-3"
                                        onClick={handleClear}
                                        disabled={dataSubLoading}
                                    >
                                        Clear
                                    </button>

                                    <button
                                        className="btn btn-primary col-3"
                                        onClick={handleSubmit}
                                        disabled={dataSubLoading}
                                    >
                                        {dataSubLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                {editMode ? "Updating..." : "Submitting..."}
                                            </>
                                        ) : (
                                            editMode ? "Update" : "Submit"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}